import { Embed } from "@/features/embeds";
import type { Tool, ToolProps } from "@/types/tools";
import { DatabaseOutlined } from "@ant-design/icons";
import { Alert } from "antd";
import { TpuTutorial } from "./tutorial";
const TpuRiskTable = (props: ToolProps) => {
  return <div className="mb-8 flex w-full flex-col" data-sentry-component="TpuRiskTable" data-sentry-source-file="index.tsx">
      <Embed className="mb-8 w-full flex-1" data={{
      type: "metabaseDashboard",
      id: "b33be0c4-d6c3-42ba-b22d-04640d4e2516"
    }} data-sentry-element="Embed" data-sentry-source-file="index.tsx" />
      <Alert description={<>
            <b>Disclaimer:</b> The HKMA has engaged a service provider to provide services in relation to this Platform.
            This database contains downloadable data which have been cleansed and/or transformed by the service
            provider, as well as links to external sources. Inclusion in the database does not indicate use of or
            endorsement by the HKMA.
          </>} type="info" data-sentry-element="Alert" data-sentry-source-file="index.tsx" />
      <TpuTutorial onClose={() => props.setIsTutorialOpen(false)} open={props.isTutorialOpen} data-sentry-element="TpuTutorial" data-sentry-source-file="index.tsx" />
    </div>;
};
export default {
  id: "tpu-risk-table",
  category: "reference",
  keyPrefix: "reference.tpuRiskTable",
  maxWidth: "100%",
  icon: <DatabaseOutlined />,
  render: props => <TpuRiskTable {...props} />,
  hasTutorial: true,
  overrides: {
    menuLabel: "Physical Risk Table"
  }
} as Tool;